import { useState, useEffect } from 'react';
import { useModal } from '../../contexts/ModalContext';

export default function ConsultModal() {
  const { isOpen, closeModal } = useModal();
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
      setSubmitted(false);
    }
    return () => { document.body.style.overflow = ''; };
  }, [isOpen]);

  if (!isOpen) return null;

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setSubmitting(true);
    const form = e.currentTarget;
    const data = new URLSearchParams();
    const formData = new FormData(form);
    formData.forEach((value, key) => {
      data.append(key, value.toString());
    });
    try {
      await fetch('https://readdy.ai/api/form/d71fi49lum2co2q1fn50', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: data.toString(),
      });
      setSubmitted(true);
    } catch {
      setSubmitted(true);
    }
    setSubmitting(false);
  };

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
      <div
        className="absolute inset-0 bg-charcoal/70 backdrop-blur-sm cursor-pointer"
        onClick={closeModal}
      />
      <div className="relative bg-soft-white w-full max-w-lg max-h-[90vh] overflow-y-auto">
        <div className="p-10">
          <button
            onClick={closeModal}
            className="absolute top-6 right-6 text-warm-gray hover:text-charcoal transition-colors cursor-pointer w-8 h-8 flex items-center justify-center"
          >
            <i className="ri-close-line text-xl" />
          </button>

          {submitted ? (
            <div className="text-center py-8">
              <div className="w-12 h-12 flex items-center justify-center mx-auto mb-6">
                <i className="ri-check-line text-3xl text-wood" />
              </div>
              <h3 className="font-serif text-2xl font-light text-charcoal mb-3">Thank You</h3>
              <p className="font-sans text-sm text-warm-gray leading-relaxed">
                We&apos;ve received your request and will be in touch shortly to schedule your consultation.
              </p>
            </div>
          ) : (
            <>
              <div className="mb-8">
                <p className="font-sans text-xs tracking-widest uppercase text-wood mb-2">Begin Here</p>
                <h3 className="font-serif text-3xl font-light text-charcoal">Schedule a Consultation</h3>
              </div>

              <form
                onSubmit={handleSubmit}
                data-readdy-form
                id="consult-form"
                className="space-y-5"
              >
                <div>
                  <label className="block font-sans text-xs tracking-wider uppercase text-warm-gray mb-2">
                    Full Name *
                  </label>
                  <input
                    name="name"
                    type="text"
                    required
                    className="w-full border border-stone bg-transparent px-4 py-3 font-sans text-sm text-charcoal focus:outline-none focus:border-charcoal transition-colors"
                    placeholder="Your full name"
                  />
                </div>

                <div>
                  <label className="block font-sans text-xs tracking-wider uppercase text-warm-gray mb-2">
                    Email Address *
                  </label>
                  <input
                    name="email"
                    type="email"
                    required
                    className="w-full border border-stone bg-transparent px-4 py-3 font-sans text-sm text-charcoal focus:outline-none focus:border-charcoal transition-colors"
                    placeholder="your@email.com"
                  />
                </div>

                <div>
                  <label className="block font-sans text-xs tracking-wider uppercase text-warm-gray mb-2">
                    Phone Number
                  </label>
                  <input
                    name="phone"
                    type="tel"
                    className="w-full border border-stone bg-transparent px-4 py-3 font-sans text-sm text-charcoal focus:outline-none focus:border-charcoal transition-colors"
                    placeholder="(914) 000-0000"
                  />
                </div>

                <div>
                  <label className="block font-sans text-xs tracking-wider uppercase text-warm-gray mb-2">
                    Project Type
                  </label>
                  <select
                    name="project_type"
                    className="w-full border border-stone bg-soft-white px-4 py-3 font-sans text-sm text-charcoal focus:outline-none focus:border-charcoal transition-colors cursor-pointer"
                  >
                    <option value="">Select project type</option>
                    <option value="Custom Home Design">Custom Home Design</option>
                    <option value="Renovation & Addition">Renovation &amp; Addition</option>
                    <option value="New Home Design">New Home Design</option>
                    <option value="Interior Spatial Planning">Interior Spatial Planning</option>
                    <option value="Other">Other</option>
                  </select>
                </div>

                <div>
                  <label className="block font-sans text-xs tracking-wider uppercase text-warm-gray mb-2">
                    Tell Us About Your Project
                  </label>
                  <textarea
                    name="message"
                    rows={4}
                    maxLength={500}
                    className="w-full border border-stone bg-transparent px-4 py-3 font-sans text-sm text-charcoal focus:outline-none focus:border-charcoal transition-colors resize-none"
                    placeholder="Brief description of your project and goals..."
                  />
                </div>

                <button
                  type="submit"
                  disabled={submitting}
                  className="w-full bg-charcoal text-soft-white font-sans text-xs tracking-widest uppercase py-4 hover:bg-wood transition-colors duration-300 cursor-pointer whitespace-nowrap disabled:opacity-60"
                >
                  {submitting ? 'Sending...' : 'Send Request'}
                </button>
              </form>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
